/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 功能开关
 */
export const SWITCH = {
    /**
     * 是否支持NAS。在Dorado 3000/5300产品型号中不支持NAS，启动DM时在before_start.py中会将该值设置为false，nas license会影响该值
     */
    SUPPORT_NAS: true,
    /**
     * 是否支持330的性能监控指标
     */
    SUPPORT_INDICATOR_330: false,
    /**
     * 是否支持智能GUI,arm环境下会被置为true
     */
    SUPPORT_SMART_GUI: true,
    /**
     * 当前产品是否支持NAS。从产品设备/OSM/conf/sys/spec/product.ini中读出，与NAS LICENSE无关
     */
    PRODUCT_SUPPORT_NAS: true,
    /**
     * LICENSE是否支持NAS。导入NAS license就可以创建NAS相关权限的角色
     */
    LICENSE_SUPPORT_NAS: false,
    /**
     * 是否支持容器
     */
    SUPPORT_CONTAINER: true,
    /**
     * 是否是租户系统
     */
    IS_VSTORE_SYSTEM: false,
    /**
     * 是否是虚拟机页面
     */
    IS_VIRTUAL_MACHINE_CONSOLE: false,
    /**
     * 存储池支持X盘起配
     */
    SUPPORT_X_DISK_CREATE_POOL: false,

    /**
     * 当前是否为极简模式，初始值true和false都会导致刷新时菜单闪现，这里特殊处理一下。
     */
    IS_SIMPLE_MODE: undefined,
    /**
     * 高级搜索中是否屏蔽数据保护快捷入口
     */
    IS_HIDE_PROTECTION: undefined,
    /**
     * 是否是计算型存储2910
     */
    // @ts-expect-error: 计算型存储
    IS_2910: PRODUCT_TYPE === 'ocean_lite',

    /**
     * 是否是dbStore5910
     */
    IS_5910: false,

    /**
     * 是否是二级存储
     */
    // @ts-expect-error: 二级存储
    IS_OCEAN_PROTECT: PRODUCT_TYPE === 'ocean_protect',

    /**
     * 是否是微存储
     */
    // @ts-expect-error: 微存储
    IS_OCEAN_MICRO: PRODUCT_TYPE === 'ocean_micro' || PRODUCT_TYPE === 'micro_unified',

    /**
     * 是否是微存储混闪
     */
    // @ts-expect-error: 微存储混闪
    IS_MICRO_UNIFIED: PRODUCT_TYPE === 'micro_unified',

    /**
     * 是否是dorado
     */
    // @ts-expect-error: Dorado
    IS_DORADO_PROTECT: PRODUCT_TYPE === 'dorado' || PRODUCT_TYPE === 'dorado_2000' || PRODUCT_TYPE === 'dbstore',

    /**
     * 是否是新融合
     */
    // @ts-expect-error: 新融合
    IS_CONVERGED_PROTECT: PRODUCT_TYPE === 'converged_storage' || PRODUCT_TYPE === 'lite_converged',

    /**
     * 是否是DBStore
     */
    // @ts-expect-error: 数据库存储
    IS_DBSTORE: PRODUCT_TYPE === 'dbstore',

    /**
     * 是否已导入基本license
     */
    IS_SMARTTHIN_IMPORT: false,

    /**
     * 是否是国内型号
     */
    IS_DOMESTIC_MODEL: true,

    /**
     * 是否有存储池软加密License
     */
    HAS_SOFT_ENCRYPT_LICENSE: false,

    /**
     * 是否有存储池国密License
     */
    HAS_SOFT_ENCRYPT_SM4_LICENSE: false,

    /**
     * 是否是微存储直通模式
     */
    IS_DIRECT_MODE: false,

    /**
     * 是否是池化可得容量模式
     */
    IS_AvailableCap_MODE: false,

    /**
     * 是否隐藏omtask接口下发后的侧滑框实时任务。LLT场景会默认改为默认关闭
     */
    HIDE_BATCH_TASK_RESULT: false,

    /**
     * 根据产品配置文件读取是否支持AI特性（smartGUI智能推荐、智能告警修复，PMS容量预测、性能预测、异常检测）
     */
    PRODUCT_SUPPORT_AI: true,

    /**
     * 表格导出功能
     */
    SHOW_TABLE_EXPORT: true,
    /**
     * NFS over RDMA功能。当前支持dorado、新融合
     */
    SUPPORT_NFS_OVER_RDMA: false,
    /**
     * 容器前端端口支持配置业务需求特性开关
     */
    SUPPORT_CONTAINER_FRONT_PORT: false,
    /**
     * KV相关对象监控
     */
    SUPPORT_KV_MONITOR: false,
    /**
     * SmartMove需求特性开关
     */
    SUPPORT_SMART_MOVE: false,
    /**
     * NetSpace需求特性开关
     */
    SUPPORT_NET_SPACE: false,
    /**
     * 是否支持保留一致性快照
     */
    IS_SUPPORT_RES_CST_SNAPSHOT: false,
    /**
     * 是否支持NAS环形3dc
     */
    IS_SUPPORT_NAS_RING_3DC: false,
    /**
     * 性能监控支持同步复制
     */
    PERFORMANCE_SUPPORT_SYNC_REPLICATION: false,
    /**
     * 是否支持开局模式告警
     */
    SUPPORT_DEPLOYMENT_MODE_WARNING: false,
    /**
     * 是否支持波动检测
     */
    SUPPORT_ABNORMAL_DETECTION: false,
    /**
     * 是否支持预测中的性能预测
     */
    SUPPORT_PERFORMANCE_PREDICT: false,
    /**
     * 是否支持容量预测
     */
    SUPPORT_CAPACITY_PREDICT: false,
    /**
     * 是否支持故障树诊断
     */
    SUPPORT_FAULT_TREE_DIAGNOSIS: false,
    /**
     * 管理口支持显示IP模式
     */
    SUPPORT_MANAGEMENT_PORT_SHOW_IP_MODE: false,
    /**
     * 维护口支持修改IP模式
     */
    SUPPORT_MAINTENANCE_PORT_MODIFY_IP_MODE: false,
    /**
     * 支持数据备份逻辑端口
     */
    SUPPORT_DATA_BACKUP_LOGIC_PORT: false,
    /**
     * 支持系统管理逻辑端口
     */
    SUPPORT_SYSTEM_MANAGEMENT_LOGIC_PORT: false,
    /**
     * 支持显示交换机
     */
    SUPPORT_SHOW_SWITCH: false,
};

/**
 * shard开发，特性代码开关
 */
export const ShardSwitch = {
    /**
     * cloudtier shard开关
     */
    CLOUD_TIER: true,
    /**
     * cloudtier shard开关
     */
    CLOUD_TIER_TEMPLATE: true,
    /**
     * 新eService设置
     */
    SHOW_ESERVICE_SETTING: true,
    /**
     * 文件服务域和CA服务器证书是否支持吊销列表
     */
    IS_FS_AND_CA_SUPPORT_REOLIST: true,
    /**
     * 通道LUN
     */
    CHANNEL_LUN: true,
    /**
     * 容器下的repository shard开关
     */
    CONTAINER_REPOSITORY_AVAILABLE: true,
    /**
     * 内置CA
     */
    BUILT_IN_CA: false,
    /**
     * V6-dashboard监控NAS性能指标增强
     */
    SHOW_DASHBOARD_INDICATOR_ENHANCE: true,
    /**
     * 二级存储支持4盘[缓存盘]起配
     */
    SHOW_FOUR_CACHE_DISK: true,
    /**
     * 创FS里的防病毒
     */
    SHOW_ANTIVIRUS_IN_FS_CREATE: true,
    /**
     * 性能需求开关
     */
    SHOW_PERFORMANCE_ANOMALY_ENHANCE: true,
    /**
     * 支持系统级smartQos特性 shard开关
     */
    SHOW_SYSTEM_SMARTQOS: true,
    /**
     * CIFS支持添加unix用户
     */
    CIFS_ADD_UNIX: true,
    /**
     * LUN创克隆，加存储池
     */
    SHOW_POOL_IN_LUN_CLONE_CREATE: true,
    /**
     * LUN创克隆一致性组，加存储池
     */
    SHOW_POOL_IN_LUN_CGCLONE_CREATE: true,
    /**
     * 支持AP模式文件系统双活域
     */
    SHOW_NAS_DOMAIN_AP: true,
    /**
     * 微存储混闪支持namespace缓存策略
     */
    SHOW_CACHE_POLICY_IN_MICRO_UNIFIED: true,
    /**
     * 支持AP模式文件系统双活域优先站点模式切换
     */
    SHOW_AP_NAS_HM_SWAP: true,
    /**
     * 5910迭代二shard开关
     */
    IS_5910_SHARD3: false,
    /**
     * 性能码表
     */
    CODE_TABLE: false,
    /**
     * 支持FCV单点登录精准跳转
     */
    SUPPORT_FCV_SSO_JUMP: true,
    /**
     *  617初始化配置DME IQ
     */
    INTIALIZE_DME_IQ: true,
    /**
     * 617-支持取消非危险类高危提示
     */
    DISABLE_PROMPT: true,
    /**
     * 支持容量指标选择
     */
    SUPPORT_CAPACITY_INDICATOR: true,
    /**
     * 自定义提示
     */
    SHOW_CUSTOM_PROMPT: false,
    /*
     * 文件系统展示应用类型列
     */
    SHOW_APPLICATION_TYPE_IN_FS: false,
};

/**
 * 从产品设备/OSM/conf/sys/spec/product.ini中读出的配置
 * 需要在业务代码中判断是否为有效值，并且写一个兜底值判断，避免获取配置文件失败导致页面功能失效
 * !请勿在此处配置兜底值
 */
export const ProductConfig = {
    /**
     * 块CDP计划-按个数
     */
    MaxLunHyperCdpFreqNum: undefined,
    /**
     * 块CDP计划-每天-单个成员保留个数
     */
    MaxLunHyperCdpDailyNum: undefined,
    /**
     * 块CDP计划-每周-单个成员保留个数
     */
    MaxLunHyperCdpWeekqNum: undefined,
    /**
     * 块CDP计划-每月-单个成员保留个数
     */
    MaxLunHyperCdpMonthNum: undefined,
    /**
     * 文件CDP计划-按个数
     */
    MaxFsHyperCdpFreqNum: undefined,
    /**
     * 文件CDP计划-每天-单个成员保留个数
     */
    MaxFsHyperCdpDailyNum: undefined,
    /**
     * 文件CDP计划-每周-单个成员保留个数
     */
    MaxFsHyperCdpWeekqNum: undefined,
    /**
     * 文件CDP计划-每月-单个成员保留个数
     */
    MaxFsHyperCdpMonthNum: undefined,
    /**
     * 是否支持重删 0表示不支持重删，1表示支持重删
     */
    isSupportDedup: undefined,
    /**
     * 性能层起配盘数量（新融合只选择SSD盘创建存储池时最少所需的盘数量）
     */
    MinSsdDiskNumberInDisklessDomain: undefined,
    /**
     * 性能层起配盘数量对应的最少热备盘数量（除2910外，低于8SSD盘的全闪存储池至少需要1个热备）
     */
    DefaultSsdHotSpareDiskNum: undefined,
    /**
     * 性能层配额最小值(默认2TB, 2910为1TB, 5310和入门级存储6盘起配为1TB，配置文件里配置的是GB)
     */
    MinLogicCapacitySpecInDisklessDomain: undefined,
    /**
     * 存储池创建-可选控制框上限，默认为2
     */
    MaxEngNumPerDiskPool: undefined,
    /**
     * 主机支持的操作系统枚举
     */
    SupportHostOsListTypeE: undefined,
    /**
     * 存储池“总订阅容量”和“已使用订阅容量”使用接口字段
     */
    IsUseSubscribedCapacity: undefined,
    /**
     * 是否支持极简模式(入门级存储+低端部分型号支持)
     */
    IsSupportSimpleMode: undefined,
    /**
     * 是否支持Box硬件 术语变更 riser-->carrier-->box
     */
    isSupportCarrier: undefined,
    /**
     * 是否支持不需要license控制DataTurboOverRoCE数据协议逻辑端口(A800)
     * 相比license控制的DataTurboOverRoce数据协议逻辑端口差异点：支持配置&修改DNS zone和侦听DNS查询请求;支持修改主端口;支持配置&修改IPV6
     */
    isSupportDataTurboOverRoceProtocolLif: undefined,
    /**
     * 是否支持SmartMobility特性重删分级开关
     */
    isSupportSmartMobilityDedupSwitch: undefined,
    /**
     * 是否屏蔽Dtree特性
     */
    isHideDtree: undefined,
    /**
     * 是否仅支持UNIX安全模式
     */
    isOnlySupportUnixSecurityStyle: undefined,
    /**
     * 是否屏蔽克隆文件系统特性
     */
    isHideCloneFileSystem: undefined,
    /**
     * 是否屏蔽目录配额
     */
    isHideDtreeQuota: undefined,
    /**
     * 是否屏蔽windows用户配额
     */
    isHideWindowsUserQuota: undefined,
    /**
     * 文件系统是否支持VAAI能力开关(2910,二级存储,A800不支持)
     */
    isSupportVAAISwitch: undefined,
    /**
     * 是否支持快照对比(2910,A800不支持)
     */
    isSupportSnapDiffSwitch: undefined,
    /*
     * 是否屏蔽文件系统(快照特性相关字段)
     */
    isHideFsSnapshotFeature: undefined,
    /**
     * 是否屏蔽审计日志
     */
    isHideAuditFs: undefined,
    /**
     * 是否屏蔽NFS共享[显示快照字段]
     */
    isHideNfsSnapShot: undefined,
    /**
     * 是否屏蔽CIFS
     */
    isHideCifs: undefined,
    /**
     * 是否屏蔽windows用户、用户映射
     */
    isHideWindowsUserFeature: undefined,
    /**
     * 是否屏蔽AD域
     */
    isHideAdDomain: undefined,
    /**
     * 是否屏蔽NFS共享文件扩展名
     */
    isHideNfsFileFiltering: undefined,
    /**
     * 是否屏蔽kerberos
     */
    isHideKerberos: undefined,
    /**
     * 是否屏蔽CIFS共享文件扩展名
     */
    isHideCifsFileFiltering: undefined,
    /**
     * 是否支持NDMP服务(A800,2910,入门级不支持)
     */
    isSupportNDMP: undefined,
    /**
     * FS是否过滤重删压缩应用类型
     */
    isCompressDedupFilterEnabled: undefined,
    /**
     * 支持防病毒（A800和二级存储和微存储不支持）
     */
    isSupportAntivirus: undefined,
    /**
     * 是否支持高性能客户端性能监控
     */
    isSupportDpcfsClient: undefined,
    /**
     * 是否屏蔽存储池部分lun相关参数（A800屏蔽）
     */
    isHideStoragePoolPara: undefined,
    /**
     * 创建存储池是否隐藏共享性能层策略，只支持创建独享策略(QLC型号)
     */
    isHideSharePerformanceLayer: undefined,
    /**
     * 是否支持TCP/RDMA混跑(A800支持)，如果支持，数据协议选择NFS时端口类型可以选择RoCE端口
     */
    isSupportTcpRdmaMix: undefined,
    /**
     * 屏蔽逻辑端口复制角色类型（A800屏蔽）
     */
    isHideLifRepRole: undefined,
    /**
     * 逻辑端口、漂移组是否支持S3协议类型（dorado支持）
     */
    isSupportS3Protocol: undefined,
    /**
     * 是否支持双活租户Pair(2910,微存储,二级存储,A800不支持)
     */
    isSupportVstoreHyperMetroPair: undefined,
    /**
     * 隐藏容量自适应策略
     */
    isHideFsAutoScaling: undefined,
    /**
     * 是否屏蔽屏蔽升级、OTA升级和补丁(A800屏蔽)
     */
    isHideUpgrade: undefined,
    /**
     * 是否屏蔽创建租户、删除租户(A800屏蔽)
     */
    isHideCreateAndDeleteVStore: undefined,
    /**
     * SmartQos修改运行状态描述
     */
    supportQosNewRunningStatus: undefined,
};
